import CmlRatebaseIndex from "@/components/billing_cml/ratebase/RatebaseIndex.vue";
import CmlRatebaseAdd from "@/components/billing_cml/ratebase/RatebaseAdd.vue";
import CmlRatebaseDetail from "@/components/billing_cml/ratebase/RatebaseDetail.vue";
import CmlRatebaseEdit from "@/components/billing_cml/ratebase/RatebaseEdit.vue";

let routesRatebaseAccess= [
    {
        path: '',
        meta: {
          title: "CML List Ratebase",
        },
        name: "CmlRatebaseIndex",
        component: CmlRatebaseIndex
    },
    {
        path: 'create',
        meta: {
          title: "CML Create Ratebase",
        },
        name: "CmlRatebaseAdd",
        component: CmlRatebaseAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "CML Detail Ratebase",
        },
        name: "CmlRatebaseDetail",
        component: CmlRatebaseDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "CML Edit Ratebase",
        },
        name: "CmlRatebaseEdit",
        component: CmlRatebaseEdit
    },
    
]

export default routesRatebaseAccess
  